export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11220.e36cf4bb.jpg";